
(function fileDetailControllerDefinition() {
    'use strict';

    angular.module('File')
        .controller('FileDetailController', [
            '$scope', 'config', '$state', '$translate', '$stateParams', 'errorsExtend', 'fileService', 'authExtend',
            function fileDetailController($scope, config, $state, $translate, $stateParams, errors, fileService, auth) {

                $scope.auditEntity = {
                    creationDate: new Date(),
                    userId: auth.getUserId(),
                    userName: auth.getUserNick(),
                    applicationId: config.appId(),
                    applicationName: config.appName(),
                    organizationalUnitId: auth.getOrganizationId(),
                    organizationalUnitName: auth.getOrganizationName(),
                    actionType: { id: 37 }//FileDownLoad
                };



                $scope.cancel = function () {
                    //stateFileToComeBack         
                    $state.go('document-detail', { id: $stateParams.id });
                };

                $scope.load = function () {
                    fileService.getById($stateParams.id).then(function (result) {
                        $scope.content = 'data:application/pdf;base64,' + result.value.base64File;

                        $scope.auditEntity.entity = JSON.stringify({
                            documentId: result.value.documentVersionDocumentId,
                            documentName: result.value.documentVersionName,
                            fileCreatedBy: result.value.createdByNickName,
                            fileCreationDate: result.value.creationDate,
                            fileDownloadedBy: auth.getUserId(),
                            fileDownloadedDate: new Date(),
                            organizationalUnit: auth.getOrganizationId(),
                        });

                        $scope.file = result;

                        $translate(['FileDetail']).then(function (translated) {
                            $scope.title = translated.FileDetail + $scope.file.name;
                        });
                    }, function (error) {
                        if (error.status === 204) {
                            errors.showWarning('The document has no files');
                        } else {
                            errors.showError('Api failed');
                        }
                        $scope.cancel();
                    });
                }

                $scope.load();

            }
        ]);
})();